import { DefaultButton, PrimaryButton } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import "./UserColumn.css"
import { getEnv } from "../../helpers/EnvHelper";

export const AdminUserColumns = (userId, handleActionButton, handleUserClick, handleLockButton) => {

  const {t} = useTranslation();
  const childTrPadding = (getEnv("REACT_APP_HYBRID_MODE") == "false") ? "15px 0px 15px 10px" : "15px 10px";
  const rowTrPadding = "0px 10px";

  return [
    {
      id: "username",
      style: { width: "25%", boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: {padding:childTrPadding, textAlign: "left", width: "25%", boxSizing:'border-box'},
      headerClass:"break-word",
      classChildName:
          "break-word cursor-pointer",
      header: () => (
        <span className="">Details</span>
      ),
      accessor: "clients",
      accessorKey: "clients",
      show: true,
      cell: (info) =>  <>
      <div>
          <div className="user-heading">{t("user.username")}</div>
          <div className="user-sub-heading">{info.row.original.username}</div>
      </div>

      <div className="user-mt-10">
          <div className="user-heading">Full Name</div>
          <div className="user-sub-heading">{info.row.original.firstName}{" "}{info.row.original.lastName}</div>
      </div>
    </>,
    },
    {
      id: "email",
      style: { width: "30%", boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: {padding:childTrPadding, textAlign: "left", width: "30%", boxSizing:'border-box'},
      headerClass:"break-word",
      classChildName:
          "break-word cursor-pointer",
      header: () => (
        <span className="">Contact Details</span>
      ),
      accessor: "email",
      accessorKey: "email",
      show: true,
      cell: (info) =>  <>
      <div>
          <div className="user-heading">{t("user.email")}</div>
          <div className="user-sub-heading">{info.row.original.email}</div>
      </div>

      <div className="user-mt-10">
          <div className="user-heading">{t("user.mobile")}</div>
          <div className="user-sub-heading">{info.row.original.mobile}</div>
      </div>

  </>,
    },
    {
      id: "action",
      style: { width: "45%", display:'flex', height:'80px', alignItems:'center', boxSizing:'border-box', padding:rowTrPadding },
      headerStyle: {padding:childTrPadding, textAlign: "left", width: "45%", boxSizing:'border-box'},
      headerClass:"break-word",
      classChildName:
          "break-word cursor-pointer",
      header: () => (
        <span >{t("supervisor.action")}</span>
      ),
      accessor: "action",
      accessorKey: "action",
      show: true,
      cell: (cell) => <>
      {userId != cell.row.original.id && (
        <>
        {/* <p style={{margin:'0px'}}>{!cell.row.original.active ? "Inactive" : "Active"}</p> */}
        {!cell.row.original.active ?<PrimaryButton
          text={ "Activate"}
          //text={cell.row.values.action}
          onClick={(event) =>
            handleActionButton(event, cell.row.original.id, cell)
          }
          style={{
            width: "80px",
            padding: "0",
          }}
        />
        :
        <DefaultButton
        text={"Deactivate"}
        //text={cell.row.values.action}
        onClick={(event) =>
          handleActionButton(event, cell.row.original.id, cell)
        }
        style={{
          width: "80px",
          padding: "0",
        }}
      />}

        {cell.row.original.username != 'dtadmin' && (!cell.row.original.accountNonLocked ?<PrimaryButton
            text={ "Unlock"}
            //text={cell.row.values.action}
            onClick={(event) =>
              handleLockButton(event, cell.row.original.id, cell)
            }
            style={{
              width: "80px",
              padding: "0",
              marginLeft: "20px"
            }}
          />
          :
          <DefaultButton
          text={"Lock"}
          //text={cell.row.values.action}
          onClick={(event) =>
            handleLockButton(event, cell.row.original.id, cell)
          }
          style={{
            width: "80px",
            padding: "0",
            marginLeft: "20px"
          }}
        />)}
      </>
      )}
    </>,
    },
  ];
};
